export default __webpack_public_path__ + "static/media/bg.171cb5d6.png";